import React, {Component} from "react";
import { InputField } from "../../common/custom-form/input-filter-component";
export class InvoiceLocation extends Component {
    constructor(props) {
        super(props);
        this.state={
            inputValue:""
        }
    }
    render(){
        return(
           <div>
            <div className='add-line-label'>
                <span>Location Address {this.props.countLocation > 1 && this.props.countLocation}</span>  
            </div>           
            <div className="manage-invoice-detail">
                <InputField label="LOCATION AUX ID" testInput={this.state.inputValue} onChange={(e)=>this.setState({inputValue:e.target.value})}  />
                <InputField label="SITE NAME" testInput={this.state.inputValue} onChange={(e)=>this.setState({inputValue:e.target.value})}  />
                <InputField label="ADDRESS 1" testInput={this.state.inputValue} onChange={(e)=>this.setState({inputValue:e.target.value})}  />
                <InputField label="ADDRESS 2" testInput={this.state.inputValue} onChange={(e)=>this.setState({inputValue:e.target.value})}  />
                <InputField label="CITY" testInput={this.state.inputValue} onChange={(e)=>this.setState({inputValue:e.target.value})}  />
                <InputField label="STATE" testInput={this.state.inputValue} onChange={(e)=>this.setState({inputValue:e.target.value})}  />
                <InputField label="COUNTRY / LOCATION" testInput={this.state.inputValue} onChange={(e)=>this.setState({inputValue:e.target.value})}  />
                <InputField label="ZIP" testInput={this.state.inputValue} onChange={(e)=>this.setState({inputValue:e.target.value})}  />
            </div>
           </div>
        )
    }
}